import { mutatorAction } from "satcheljs";
import { appViewState } from "sh-application/store";

export default mutatorAction('SET_SHOW_WELCOME_STATE',
    function setShowWelcomeState(visible: boolean) {
        appViewState().showWelcome = visible;
        appViewState().tourGuideViewState.showWelcome = visible;
    }
);
